/**
 * @author varun
 * sample usage:
 * eg.
 * <span jv-timer time-in-mills="{{time-in-milliseconds}}" start-timer="{{boolean value}}"></span>
 *
 * @attr
 * 		timeInMills: time in milliseconds for which the timer starts.
 * 		startTimer: Its a boolean that tells the timer when to start.
 * @event:
 * 		The timer emits a "TIMER_COMPLETE" event which you can catch in your parent scope like this.
 * 		$scope.$on("TIMER_COMPLETE", callback)
 */

angular.module("jv.Common.Timer",[ ])
 .directive("jvTimer",["$filter", function($filter){
		return {
			restrict:"A",
			scope: {
				timeInMills: "@timeInMills",
				startTimer: "@startTimer"
			},
			link: function(scope, element, attribute) {
				var intervalId = null;
				var initData = function() {
					scope.timeInMillsParsed = parseInt(scope.timeInMills);
					element.text(getTextForElement(scope.timeInMillsParsed));
				}

				function getTextForElement(timeInMilliseconds){
					var _minutes = parseInt(timeInMilliseconds/60000,10);
					var _seconds = timeInMilliseconds%60000;
					if(_minutes<10){
						_minutes = "0"+_minutes;
					}
					_seconds = _seconds/1000;
					if(_seconds<10){
						_seconds = "0"+_seconds;
					}
					return _minutes+":"+_seconds;
				}

				initData();

				var startClock = function(){
					element.text(getTextForElement(scope.timeInMillsParsed));
					scope.timeInMillsParsed -= 1000;
					intervalId = setInterval(function(){
						scope.$apply(function(){
							if(scope.timeInMillsParsed<=0){
								clearInterval(intervalId);
								//element.text($filter('date')(0, 'mm:ss'));
								element.text(getTextForElement(0));
								scope.$emit('TIMER_COMPLETE');
								return;
							}
							//{{timeInMills|date:'mm:ss'}}
							//element.text($filter('date')(scope.timeInMills, 'mm:ss'));
							element.text(getTextForElement(scope.timeInMillsParsed));
							scope.timeInMillsParsed -= 1000;
						});
					},1000);
				};

				scope.$watch("startTimer", function(newValue, oldValue){
					clearInterval(intervalId);
					if(newValue=='true' && oldValue == 'false'){
						initData();
						startClock( );
					}
				});

				scope.$watch("timeInMills", function(newValue, oldValue){
					if (newValue !== oldValue) {
						initData();
					}
				});
			}
		};
	}]);
